import { FC } from 'react';
import { FormattedMessage } from 'dibs-react-intl';
import { useFragment, graphql } from 'react-relay';

import Sold from 'dibs-icons/exports/Sold';
import HeadingLevel from 'dibs-controlled-heading/exports/HeadingLevel';
import { PdpSharedContactSellerButton } from '../../PdpSharedContactSellerButton/PdpSharedContactSellerButton';

import { PdpRespTopModule_item$key } from './__generated__/PdpRespTopModule_item.graphql';
import { PdpRespTopModule_user$key } from './__generated__/PdpRespTopModule_user.graphql';

import styles from './PdpRespTopModule.scss';

const userFragment = graphql`
    fragment PdpRespTopModule_user on User {
        ...PdpSharedContactSellerButton_user
    }
`;

const itemFragment = graphql`
    fragment PdpRespTopModule_item on Item {
        ...PdpSharedContactSellerButton_item
        title
        photos {
            smallPath
        }
        seller {
            isAccessible
        }
    }
`;

export const PdpRespTopModule: FC<{
    item: PdpRespTopModule_item$key;
    user: PdpRespTopModule_user$key;
}> = ({ ...props }) => {
    const user = useFragment(userFragment, props.user);
    const item = useFragment(itemFragment, props.item);

    return (
        <HeadingLevel>
            {Heading => (
                <div className={styles.container} data-tn="pdp-sold-heading-info">
                    <div className={styles.imageContainer}>
                        <img
                            src={item.photos?.[0]?.smallPath || ''}
                            alt={item.title || ''}
                            className={styles.image}
                        />
                    </div>

                    <div className={styles.content}>
                        <Sold className={styles.soldIcon} />
                        <Heading className={styles.title} dataTn="pdp-sold-heading-title">
                            {item.title}
                        </Heading>
                    </div>
                    {item?.seller?.isAccessible && (
                        <div className={styles.buttonContainer}>
                            <PdpSharedContactSellerButton
                                type="transparent"
                                size="medium"
                                launchOrigin="contact link in sold pdp - topnav"
                                user={user}
                                item={item}
                            >
                                <FormattedMessage
                                    id="PdpRespTopModule.messageTheSeller"
                                    defaultMessage="Message the Seller"
                                />
                            </PdpSharedContactSellerButton>
                        </div>
                    )}
                </div>
            )}
        </HeadingLevel>
    );
};
